import React from 'react';
import moment from 'moment';

const orderTableConfig = (props) => (
   {
      columns: [
         {
            title: '', field: 'order_id', filterAndSearch: false, searchable: false
         },
         // {
         //    title: 'Order Id', field: 'order_id', filterAndSearch: true,
         //    render: rowData => <div>{(rowData.order_id || "-")}</div >
         // },
         {
            title: 'Invoice Id', field: 'invoice_id', filterAndSearch: true,
            render: rowData => <div>{(rowData.invoice_id || "-")}</div >
         },
         {
            title: 'Order Date', field: 'order_date_system', filterAndSearch: true,
            render: rowData => <div>{<span>{rowData.order_date_system ? moment.utc(rowData.order_date_system).local().format("DD-MM-YYYY") : "-"}</span>}</div >
         },
         {
            title: 'Total Amount', field: 'net_amount', filterAndSearch: true,
            render: rowData => <div>{<span>&#8377;{(rowData.net_amount ? rowData.net_amount.toFixed(2) : 0)}</span>}</div >
         },
         {
            title: 'Order Amount', field: 'amount', filterAndSearch: true,
            render: rowData => <div>{<span>&#8377;{(rowData.amount ? rowData.amount.toFixed(2) : 0)}</span>}</div >
         },
         {
            title: 'Discount Amount', field: 'discount', filterAndSearch: true,
            render: rowData => <div>{<span>&#8377;{(rowData.discount ? rowData.discount.toFixed(2) : 0)}</span>}</div >
         },

         {
            title: 'Tax', field: 'tax', filterAndSearch: true,
            render: rowData => <div>{<span>&#8377;{(rowData.tax ? rowData.tax.toFixed(2) : 0)}</span>}</div >
         },
         // {
         // 	title: 'Shipping Charges', field: 'totalShippingCharges', filterAndSearch: true, 
         // 	render: rowData => <div>{(rowData.currency === "&#8377;") ? <span>&#8377;{rowData.totalShippingCharges}</span> : <span>&#36;{rowData.totalShippingCharges}</span>}</div>
         // },
         {
            title: 'Delivery Mode', field: 'delivery_option.option_name', filterAndSearch: true,
            render: rowData => <div><span>{(rowData && rowData.delivery_option ? rowData.delivery_option.option_name : "-")}</span></div >
         },
         {
            title: 'Delivery Charges', field: 'delivery_charges', filterAndSearch: true,
            render: rowData => <div>{<span>&#8377;{(rowData && rowData.delivery_charges ? rowData.delivery_charges.toFixed(2) : 0)}</span>}</div >
         },
         {
            title: 'Convience Fees', field: 'convenience_fees', filterAndSearch: true,
            render: rowData => <div>{<span>&#8377;{(rowData && rowData.convenience_fees ? rowData.convenience_fees.toFixed(2) : 0)}</span>}</div >
         },
         {
            title: 'Payable Amount', field: 'payable_amount', filterAndSearch: true,
            render: rowData => <div><b>{<span>&#8377;{(rowData.payable_amount ? rowData.payable_amount.toFixed(2) : 0)}</span>}</b></div >
         },
         {
            title: 'Packaging Chargess', field: 'packing_charges', filterAndSearch: true,
            render: rowData => <div><b>{<span>&#8377;{(rowData.packing_charges ? rowData.packing_charges.toFixed(2) : 0)}</span>}</b></div >

         },
         {
            title: 'Settlement Amount', field: 'settlement_amount', filterAndSearch: true,
            tooltip: "Settlement amount is a final payable amount. if you have set amount to 0 then that will also consider as a final amount",
            render: rowData => <div><b>{(rowData && (rowData.settlementAmount || rowData.settlementAmount === 0)
               ? <span>&#8377;{(rowData.settlementAmount).toFixed(2)}</span>
               : "-")}
            </b></div >
         },

         {
            title: 'Note', field: 'settlement_description', filterAndSearch: true, width: "350px",
            render: rowData => <div>{(rowData.settlement_description || "-")}</div >
         },
      ],
   }
)

export default orderTableConfig;
